











 














const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestToJoinOrgNotification_notification",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationTemplate_notification"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestCreatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domainJoinRequestId",
      "storageKey": null
    }
  ],
  "type": "NotifyRequestToJoinOrg",
  "abstractKey": null
};

(node ).hash = "739495e8d6e5659be867690fbb7810fb";

export default node;
